import { IconPaths } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { Button, TableSelectionBar, useModal, useToast } from '../../../../../../components'
import { GerarFaturaModal } from '../modal/GerarFaturaModal'
import { useT } from '_metronic/i18n/Metronici18n'

/** Barra da seleção: gera a fatura com os atendimentos selecionados (de uma só instituição). */
export const UsersListGrouping = () => {
  const { t } = useT()
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { selected, clearSelected } = useListView()
  const { response } = useQueryResponse()

  const openModal = () => {
    // A fatura deve pertencer à instituição dos atendimentos selecionados.
    const linhas = (response?.data ?? []).filter((row) => selected.includes(row.id))
    const empresas = new Map(
      linhas.filter((row) => row.empresa?.id).map((row) => [row.empresa?.id, row.empresa])
    )

    if (empresas.size > 1) {
      showToast({
        variant: 'warning',
        title: 'Selecione atendimentos de uma única instituição.',
        description: 'A fatura é gerada para uma instituição por vez.',
      })
      return
    }

    const empresaSelecionada = Array.from(empresas.values())[0]

    showModal({
      title: t('modal.gerar_fatura'),
      content: (
        <GerarFaturaModal
          atendimentos={selected}
          empresa={
            empresaSelecionada?.id
              ? {
                  label: empresaSelecionada.nomeFantasia ?? '',
                  value: Number(empresaSelecionada.id),
                }
              : undefined
          }
          onClose={clearSelected}
        />
      ),
    })
  }

  return (
    <TableSelectionBar count={selected.length} onClear={clearSelected}>
      <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
        {t('gerar_fatura.label')}
      </Button>
    </TableSelectionBar>
  )
}
